import React from 'react'
import abTesting from '../../services/abTesting';
import DealItemExperimental from './DealItemExperimental';
import DealOfTheDay from './DealOfTheDay';
import { Virtuoso } from 'react-virtuoso';
import { t } from '../../utilities/translator';

const MobileListVirtualized = ({
  dealsArray,
  isMultipleDestination,
  filtersInteractionCount,
  isSpecificDates,
  selectedHotel,
  bestOutOfMultiplied,
  dealOfTheDay,
  dotdPending,
}) => {

  const handleBestOutOfDestination = (destinationId) => {
    return isMultipleDestination && filtersInteractionCount <= 6 ? bestOutOfMultiplied[destinationId] : null;
  };

  const renderDealItem = (index) => {
    const dealItem = dealsArray[index];
    const isSelected = +dealItem.hotel.provider_hotel_id === +selectedHotel.hotelId;
    const bestOutOfDestination = handleBestOutOfDestination(dealItem.destinationData.destinationId);

    const mediaLogos = (
      <div className="media-logos-results">
        <div className="hp-logos-title">{t('app.asSeenOn')}</div>
        <div className="hp-logos">
            <span className="hp-logo hp-logo_rtl" />
            <span className="hp-logo hp-logo_rtl2" />
            <span className="hp-logo hp-logo_vox" />
            <span className="hp-logo hp-logo_ntv" />
            <span className="hp-logo hp-logo_elle" />
        </div>
      </div>
    );

    return (
      <div key={dealItem.offer.offerId}>
        {!!(index === 3 && abTesting.dealOfTheDay && dealOfTheDay.length && !dotdPending && !sessionStorage.getItem('hideDealOfTheDay')) && (
          <DealOfTheDay
            dealItem={dealOfTheDay[0]}
            isSpecificDates={isSpecificDates}
            isMultipleDestination={isMultipleDestination}
            hideSettings={false}
            selected={false}
            position={index}
            bestOutOfDestination={handleBestOutOfDestination(dealOfTheDay[0].destinationData.destinationId)}
          />
        )}
        {(index === 4) && (window?.holidayFinder?.market !== 4) && mediaLogos}
        <DealItemExperimental
          dealItem={dealItem}
          isSpecificDates={isSpecificDates}
          isMultipleDestination={isMultipleDestination}
          hideSettings={false}
          selected={isSelected}
          position={index}
          bestOutOfDestination={bestOutOfDestination}
        />
      </div>
    );
  }

  return (
    <div style={{ width: '100%' }}>
      <Virtuoso
        useWindowScroll
        totalCount={dealsArray.length}
        itemContent={(index) => renderDealItem(index)}
        overscan={3}
      />
    </div>
  )
}

export default MobileListVirtualized
